import { c as _c } from "react/compiler-runtime";
import { IcoBold16, IcoCode216, IcoH116, IcoH216, IcoH316, IcoItalic16, IcoLink16, type Icon, IcoOrderedList16, IcoQuoteLeft16, IcoUnorderedList16 } from '@onefootprint/icons';
import { Dialog } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
const MarkdownInstructionsDialog = t0 => {
  const $ = _c(36);
  const {
    open,
    onClose
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "markdownInstructions"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = _temp;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let T0;
  let t10;
  let t11;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] !== onClose || $[3] !== open || $[4] !== t) {
    const markdownItems = [{
      icon: IcoH116,
      text: t(t2)
    }, {
      icon: IcoH216,
      text: t(_temp2)
    }, {
      icon: IcoH316,
      text: t(_temp3)
    }, {
      icon: IcoLink16,
      text: t(_temp4)
    }, {
      icon: IcoQuoteLeft16,
      text: t(_temp5)
    }, {
      icon: IcoUnorderedList16,
      text: t(_temp6)
    }, {
      icon: IcoOrderedList16,
      text: t(_temp7)
    }, {
      icon: IcoCode216,
      text: t(_temp8)
    }, {
      icon: IcoBold16,
      text: t(_temp9)
    }, {
      icon: IcoItalic16,
      text: t(_temp10)
    }];
    const renderMarkdownItem = _temp11;
    T0 = Dialog;
    t7 = open;
    t8 = onClose;
    if ($[15] !== t) {
      t9 = t(_temp12);
      $[15] = t;
      $[16] = t9;
    } else {
      t9 = $[16];
    }
    t10 = "compact";
    t11 = true;
    t5 = "flex flex-col gap-6";
    let t12;
    if ($[17] !== t) {
      t12 = t(_temp13);
      $[17] = t;
      $[18] = t12;
    } else {
      t12 = $[18];
    }
    if ($[19] !== t12) {
      t6 = <p className="text-body-2">{t12}</p>;
      $[19] = t12;
      $[20] = t6;
    } else {
      t6 = $[20];
    }
    t3 = "flex flex-col gap-1";
    t4 = markdownItems.map(renderMarkdownItem);
    $[2] = onClose;
    $[3] = open;
    $[4] = t;
    $[5] = T0;
    $[6] = t10;
    $[7] = t11;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    T0 = $[5];
    t10 = $[6];
    t11 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
    t6 = $[11];
    t7 = $[12];
    t8 = $[13];
    t9 = $[14];
  }
  let t12;
  if ($[21] !== t3 || $[22] !== t4) {
    t12 = <div className={t3}>{t4}</div>;
    $[21] = t3;
    $[22] = t4;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t12 || $[25] !== t5 || $[26] !== t6) {
    t13 = <div className={t5}>{t6}{t12}</div>;
    $[24] = t12;
    $[25] = t5;
    $[26] = t6;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== T0 || $[29] !== t10 || $[30] !== t11 || $[31] !== t13 || $[32] !== t7 || $[33] !== t8 || $[34] !== t9) {
    t14 = <T0 open={t7} onClose={t8} title={t9} size={t10} isConfirmation={t11}>{t13}</T0>;
    $[28] = T0;
    $[29] = t10;
    $[30] = t11;
    $[31] = t13;
    $[32] = t7;
    $[33] = t8;
    $[34] = t9;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  return t14;
};
export default MarkdownInstructionsDialog;
function _temp($) {
  return $.heading1;
}
function _temp2($_0) {
  return $_0.heading2;
}
function _temp3($_1) {
  return $_1.heading3;
}
function _temp4($_2) {
  return $_2.hyperlink;
}
function _temp5($_3) {
  return $_3.blockquote;
}
function _temp6($_4) {
  return $_4.unorderedList;
}
function _temp7($_5) {
  return $_5.orderedList;
}
function _temp8($_6) {
  return $_6.inlineCode;
}
function _temp9($_7) {
  return $_7.bold;
}
function _temp10($_8) {
  return $_8.italic;
}
function _temp11(t0) {
  const {
    icon: IconComponent,
    text
  } = t0;
  return <div className="flex gap-6 items-center"><IconComponent /><p className="text-body-2">{text}</p></div>;
}
function _temp12($_9) {
  return $_9.title;
}
function _temp13($_10) {
  return $_10.description;
}